export default "__VITE_ASSET__c97cedf3__"